module.exports = __webpack_public_path__ + "static/media/banner-1.1121c7ee.jpeg";